import { render, staticRenderFns } from "./ProductMenu.vue?vue&type=template&id=1c0e2593&"
import script from "./ProductMenu.vue?vue&type=script&lang=js&"
export * from "./ProductMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProductMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports